module.exports = __webpack_public_path__ + "static/img/bussinessTv4.473aea5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bussinessTv4.png
// module id = HwkK
// module chunks = 2